import "./RolesRightsUI.css";

import { EnhancedIOSSwitch, FieldLayout, LabelPosition } from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { Grid, useTheme } from "@mui/material";

import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { ObjectUtils } from 'primereact/utils';

interface IRolesRightsDataTable {
	rolesRightsUpdatedData: (data: any) => void;
	rolesRightsDataItems: any;
	rolesRightsAndPermissionsHeaderColumns: any;
	roleRightsAndPermissionsSavedData: any;
}
export const RolesRightsDataTable: FC<IRolesRightsDataTable> = ({
	rolesRightsUpdatedData,
	rolesRightsDataItems,
	rolesRightsAndPermissionsHeaderColumns,
	roleRightsAndPermissionsSavedData
}) => {
	const theme = useTheme();
	const [rolesRights, setRolesRights] = useState<any>(
		rolesRightsDataItems
	);
	const [roleRightsAndPermissionsSavedDataUpdated, setRoleRightsAndPermissionsSavedData] = useState<any>(
		roleRightsAndPermissionsSavedData
	);

	// useEffect(() => {
	// 	rolesRightsUpdatedData(rolesRights);
	// }, [rolesRights]);
	useEffect(() => {
		rolesRightsUpdatedData(roleRightsAndPermissionsSavedDataUpdated);
	}, [roleRightsAndPermissionsSavedDataUpdated]);
	useEffect(() => {
		if (rolesRightsDataItems) {
			setRolesRights(rolesRightsDataItems);
		}
	}, [rolesRightsDataItems]);

	useEffect(() => {
		if (roleRightsAndPermissionsSavedData) {
			setRoleRightsAndPermissionsSavedData(roleRightsAndPermissionsSavedData);
		}
	}, [roleRightsAndPermissionsSavedData]);


	const [selectAll, setSelectAll] = useState(false)
	const setAllBooleansTrue = (data: any) => ({
		...data,
		screens: data.screens.map((screen: any) =>
			Object.fromEntries(
				Object.entries(screen).map(([key, value]) => [
					key,
					typeof value === "boolean" ? true : value
				])
			)
		)
	});
	const setAllBooleansFalse = (data: any) => ({
		...data,
		screens: data.screens.map((screen: any) =>
			Object.fromEntries(
				Object.entries(screen).map(([key, value]) => [
					key,
					typeof value === "boolean" ? false : value
				])
			)
		)
	});
	const onSelectAllChangeHandler = (e: any) => {
		
		let value = e.target.checked;
		setSelectAll(e.target.checked)
		if (value) {
		
			setRoleRightsAndPermissionsSavedData((prev: any) =>
				setAllBooleansTrue(prev)
			);
		} else {
			setRoleRightsAndPermissionsSavedData((prev: any) =>
				setAllBooleansFalse(prev)
			);

		}
	}
	const renderHeader = () => {
		return (
			<Grid
				container
				size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
				sx={{
					// 	display: "flex",
					// 	// justifyContent:showGlobalSearch ? "space-between" : "end",
					// 	justifyContent: "space-between",
					// 	alignItems: "center",
					// width: "20%",

				}}
			>
				{/* <div
					style={{ display: "flex" }}
				> */}
				<Grid size={{ xl: 11, lg: 11, md: 11, sm: 8, xs: 8 }}></Grid>
				<Grid size={{ xl: 1, lg: 1, md: 1, sm: 4, xs: 4 }} sx={{
					// marginLeft: "auto",
					"& .MuiSwitch-root": { marginBottom: "-10px!important" }
				}}>

					<FieldLayout
						label={"Select all"}
						labelPosition={LabelPosition.Left}
						labelColumns={8}
						fieldColumns={4}
						// fieldTopPadding={1.8}
						testId={"testId"}
					>
						<EnhancedIOSSwitch
							name="isAdmin"
							checked={selectAll}
							testId="isAdmin"
							onChangeHandler={onSelectAllChangeHandler}
						// label="Is Admin"
						/></FieldLayout>
				</Grid>
				{/* </div> */}
			</Grid>
		);
	};
	const headerSearch = renderHeader();

	// const onCellValueChange = (column: any, rowIndex: number, value: any, rowData: any) => {
	//
	// 	if (column.field === 'view' && value) {
	// 		
	// 		setRolesRights((prev: any[]) => {
	// 			const updatedData = [...prev];
	// 			const updatedRow = { ...updatedData[rowIndex], [column.field]: value };
	// 			updatedData[rowIndex] = updatedRow;
	// 			return updatedData;
	// 		});
	// 	} else if (column.field === 'view' && !value) {
	// 		setRolesRights((prev: any[]) => {
	// 			const updatedData = [...prev];
	// 			const updatedRow = { ...updatedData[rowIndex], [column.field]: value, "add": false, "update": false, "delete": false };
	// 			updatedData[rowIndex] = updatedRow;
	// 			return updatedData;
	// 		});
	// 	} else if (column.field === 'add' && value || column.field === 'update' && value || column.field === 'delete' && value) {
	// 		setRolesRights((prev: any[]) => {
	// 			const updatedData = [...prev];
	// 			const updatedRow = { ...updatedData[rowIndex], [column.field]: value, "view": true };
	// 			updatedData[rowIndex] = updatedRow;
	// 			return updatedData;
	// 		});
	// 	} else {
	// 		setRolesRights((prev: any[]) => {
	// 			const updatedData = [...prev];
	// 			const updatedRow = { ...updatedData[rowIndex], [column.field]: value };
	// 			updatedData[rowIndex] = updatedRow;
	// 			return updatedData;
	// 		});
	// 	}
	// };

	const onCellValueChange = (
		screenId: string,
		field: string,
		value: any
	) => {
		
		// if (field === 'view' && value) {
		// 	setRoleRightsAndPermissionsSavedData((prev: any) => ({
		// 		...prev,
		// 		screens: prev.screens.map((row: any) =>
		// 			row.screenId === screenId
		// 				? { ...row, [field]: value }
		// 				: row
		// 		),
		// 	}));
		// } else if (field === 'view' && !value) {
		// 	setRoleRightsAndPermissionsSavedData((prev: any) => ({
		// 		...prev,
		// 		screens: prev.screens.map((row: any) =>
		// 			row.screenId === screenId
		// 				? { ...row, [field]: value, "add": false, "update": false, "delete": false }
		// 				: row
		// 		),
		// 	}));
		// } else if (field === 'add' && value || field === 'update' && value || field === 'delete' && value) {
		// 	setRoleRightsAndPermissionsSavedData((prev: any) => ({
		// 		...prev,
		// 		screens: prev.screens.map((row: any) =>
		// 			row.screenId === screenId
		// 				? { ...row, [field]: value, "view": true }
		// 				: row
		// 		),
		// 	}));
		// } else {
		// 	setRoleRightsAndPermissionsSavedData((prev: any) => ({
		// 		...prev,
		// 		screens: prev.screens.map((row: any) =>
		// 			row.screenId === screenId
		// 				? { ...row, [field]: value }
		// 				: row
		// 		),
		// 	}));
		// }

		setRoleRightsAndPermissionsSavedData((prev: any) => ({
			...prev,
			screens: prev.screens.map((row: any) => {
				if (row.screenId !== screenId) return row;

				// 1️⃣ view unchecked → all booleans false
				if (field === "view" && value === false) {
					return Object.fromEntries(
						Object.entries(row).map(([key, val]) => [
							key,
							typeof val === "boolean" ? false : val
						])
					);
				}

				// 2️⃣ any other boolean checked → view must be true
				if (field !== "view" && typeof row[field] === "boolean" && value === true) {
					return {
						...row,
						[field]: true,
						view: true
					};
				}

				// 3️⃣ default behavior
				return {
					...row,
					[field]: value
				};
			})
		}));
	};


	const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
		return "p-component p-filled input-dropdown-fields";
	};

	// const toLabelValueArray = (str: string) =>
	// 	str.split(",").map(v => ({
	// 		value: v.trim().toLowerCase(),
	// 		label: v.trim().replace(/\b\w/g, c => c.toUpperCase())
	// 	}));
	const toLabelValueArray = (str: any) =>
		str.map((v: any) => ({
			value: v.trim().toLowerCase(),
			label: v.trim().replace(/\b\w/g, (c: any) => c.toUpperCase())
		}));


	const normalizeMultiSelectValue = (value: any) => {
		if (Array.isArray(value)) return value;
		if (typeof value === "string") return value.split(",");
		return [];
	};

	const getSavedRow = (screenId: string) =>
		roleRightsAndPermissionsSavedDataUpdated && roleRightsAndPermissionsSavedDataUpdated.screens.find(
			(s: any) => s.screenId === screenId
		);
	const columnsBody = (rowData: any, row: any, x: any) => {
		
		const fieldType = x.type;
		const baseField = x.field;

		const savedRow = getSavedRow(rowData.screenId);

		// 🔴 If this field is NOT allowed for this row → render nothing
		if (!savedRow || !(baseField in savedRow)) {
			return null;
		}

		// ✅ SWITCH
		if (fieldType === "switch") {
			return (
				<InputSwitch
					checked={!!savedRow?.[baseField]}
					onChange={(e: any) =>
						onCellValueChange(
							rowData.screenId,
							baseField,
							e.value
						)
					}
				/>
			);
		}

		// ✅ LIST
		if (fieldType === "list") {
			const listValues = rowData?.[baseField]?.values;

			return (
				<MultiSelect
					options={
						listValues && listValues !== null
							? toLabelValueArray(listValues)
							: []
					}
					value={normalizeMultiSelectValue(savedRow?.[baseField])}
					onChange={(e: any) =>
						onCellValueChange(
							rowData.screenId,
							baseField,
							e.value
						)
					}
					placeholder="--"
					className="input-dropdown-fields"
				/>
			);
		}

		// fallback (text only if allowed)
		return <span>{savedRow?.[baseField]}</span>;

		// if (x.field === "screen") {
		// 	return (
		// 		<span>
		// 			{rowData[x.field]}
		// 		</span>
		// 	);
		// } else if (x.field === "view" || x.field === "add" || x.field === "update" || x.field === "delete") {
		// 	return (
		// 		<InputSwitch checked={rowData[x.field]} onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value, rowData)} />
		// 	);
		// } else if (rowData[x.field] === "yes,no") {
		// 	return (
		// 		<InputSwitch checked={rowData[x.field]} onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value, rowData)} />
		// 	);
		// } else if (rowData[x.field]) {
		// 	return (
		// 		<MultiSelect
		// 			options={
		// 				toLabelValueArray(rowData[x.field])
		// 			}
		// 			// value={rowData[x.field]}
		// 			onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.target.value, rowData)}
		// 			placeholder="--"
		// 			className={"input-dropdown-fields"}
		// 		/>
		// 	);
		// }


	};


	return (
		<>
			<div className="card">
				<DataTable
					value={rolesRights && roleRightsAndPermissionsSavedDataUpdated && rolesRightsAndPermissionsHeaderColumns && rolesRights}
					key={JSON.stringify(roleRightsAndPermissionsSavedDataUpdated)}
					dataKey="id"
					showGridlines
					className="RolesRights"
					editMode="cell"
					resizableColumns
					columnResizeMode="expand"
					scrollable
					// reorderableColumns
					filterDisplay="menu"
					// scrollHeight="516px"
					header={headerSearch}
				>
					{rolesRightsAndPermissionsHeaderColumns && rolesRightsAndPermissionsHeaderColumns.map((x: any, index: any) => {
						return (
							<Column
								key={index}
								field={x.field}
								header={x.headerName}
								align={x.align}
								alignHeader={x.headerAlign}
								frozen={x.frozenColumn}
								columnKey={x.field}
								reorderable={false}
								style={{
									minWidth: x.minWidth,
									fontSize: "0.875rem",
									width: x.maxWidth,
									maxWidth: x.maxWidth,
								}}
								footer={x.footer}
								body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
							/>
						);
					})}
				</DataTable>
			</div>
		</>
	);
};
